<div class="ri-w-600 p-3">
    <div class="d-flex justify-content-between mb-3">
        <h5 class="fw-semibold mb-0">{{title}}</h5>
    </div>

    <div class="ri-dialog-content">
        <p>{{message}}</p>
    </div>

    <div class="ri-dialog-footer">
        <div class="d-flex justify-content-end mt-5">
            <button class="btn btn-secondary btn-sm px-5" (click)="onDismiss()"
                *ngIf="showNoButton">{{noButtonText}}</button>
            <button class="btn btn-primary btn-sm ms-1 px-5" (click)="onConfirm()">{{yesButtonText}}</button>
        </div>
    </div>
</div>
